import React from 'react';

interface SuccessNotificationProps {
    headerTitle: string,
    content: string
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({ headerTitle, content }) => {
    return (
        <div className='success'>
            <div className='d-flex w-100'>
                <div className='col-2'>
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.3">
                            <path d="M6 19C6 11.8203 11.8203 6 19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19Z" stroke="#079455" stroke-width="2" />
                        </g>
                        <g opacity="0.1">
                            <path d="M1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19Z" stroke="#079455" stroke-width="2" />
                        </g>
                        <g clip-path="url(#clip0_914_17082)">
                            <path d="M15.2513 19.0001L17.7513 21.5001L22.7513 16.5001M27.3346 19.0001C27.3346 23.6025 23.6037 27.3334 19.0013 27.3334C14.3989 27.3334 10.668 23.6025 10.668 19.0001C10.668 14.3977 14.3989 10.6667 19.0013 10.6667C23.6037 10.6667 27.3346 14.3977 27.3346 19.0001Z" stroke="#079455" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_914_17082">
                                <rect width="20" height="20" fill="white" transform="translate(9 9)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>

                <div className='col'>
                    <div className='d-flex header-title w-100'>
                        {headerTitle}
                    </div>
                    <div className='d-flex content-success-notif w-100'>
                        {content}
                    </div>
                </div>

            </div>
        </div>
    );
}
export default SuccessNotification;
